__turbopack_context__.v({
  "flag": "LanguageSelectionItem-module__fcUWTq__flag",
});
